import { useContext } from 'react'
import StatePicker, { IStateOption } from 'Components/reusable/InputFields/StatePicker'
import { IAllocation } from 'types/assignmentInterfaces'
import { StateCode } from 'types/ids'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextStateField = <T extends AnyObject>({
  field,
  stateOptions,
  insetLabel,
  ...rest
}: {
  field: EditableFieldsOfType<T, StateCode | null>
  stateOptions: IStateOption[]
  insetLabel?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: IAllocation | null) => {
    setFields({ [field]: newValue })
  }

  const dataValue = flatData[field] as unknown as StateCode

  return (
    <StatePicker
      onChange={handleChange}
      disabled={disabled[field] ?? false}
      value={dataValue}
      label={t(`${localeBase}.${field}`)}
      stateOptions={stateOptions}
      insetLabel={insetLabel}
      {...rest}
    />
  )
}

/**
 * Country picker.
 */
